import { render, staticRenderFns } from "./user-record-stat.vue?vue&type=template&id=5637e9dd&scoped=true&"
import script from "./user-record-stat.vue?vue&type=script&lang=js&"
export * from "./user-record-stat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5637e9dd",
  null
  
)

export default component.exports